export const formatError = (error) => {
  let message = 'Ocurrió un error';
  let response = null;
  let fullText = '';

  if (error.response) {
    const { status, statusText, data } = error.response;

    message = data?.message || data?.msg || `Error ${status}: ${statusText}`;
    response = data;

    fullText = `=== ERROR ===
Mensaje: ${message}
Código: ${status}
Estado: ${statusText}
URL: ${error.config?.url || 'N/A'}
Método: ${error.config?.method?.toUpperCase() || 'N/A'}
Timestamp: ${new Date().toISOString()}

=== RESPUESTA ===
${JSON.stringify(data, null, 2)}

Reportado desde: ${window.location.href}`;
  } else if (error.request) {
    message = 'Error de conexión. Verifica tu red.';
    fullText = `=== ERROR DE RED ===
Mensaje: ${message}
URL: ${error.config?.url || 'N/A'}
Timestamp: ${new Date().toISOString()}`;
  } else {
    message = error.message || String(error);
    fullText = `=== ERROR ===
Mensaje: ${message}
Timestamp: ${new Date().toISOString()}`;
  }

  return { message, response, fullText };
};

export const copyToClipboard = async (text) => {
  try {
    // Intentar Clipboard API con check de contexto seguro
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    // Fallback para contextos inseguros o browsers legacy
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;left:-9999px;opacity:0';
    document.body.appendChild(ta);
    ta.focus();
    const success = document.execCommand('copy');
    document.body.removeChild(ta);
    return success;
  } catch (err) {
    console.error('Error al copiar:', err);
    return false;
  }
};
